import { RouteConfig } from 'vue-router/types/router';

export default [{ path: '/', redirect: '/realtor/425453fa-21e6-465e-b639-b1115f8d7c43' }] as Array<RouteConfig>;
